module.exports = __webpack_public_path__ + "static/media/barbuda-23.694ecbff.jpg";